// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__RLayv","navbarScrollCustom":"carroFicha_navbarScrollCustom__AkxnF","rectangle":"carroFicha_rectangle__JXky3"};